import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import anzegWordmark from "../assets/anzeg-wordmark.png";
import "./NavBar.scss";

function NavBar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navBar">
      <div className="navBar__logo">
        <Link to="/" onClick={closeMenu}>
          <img src={anzegWordmark} alt="ANZEG" />
          <strong>institute</strong>
        </Link>
      </div>

      <ul className={menuOpen ? "navBar__links navBar__links--open" : "navBar__links"}>
        <li>
          <NavLink to="/membership" onClick={closeMenu}>Membership</NavLink>
        </li>
        <li>
          <NavLink to="/past-events" onClick={closeMenu}>Past Events</NavLink>
        </li>
        <li>
          <NavLink to="/events" onClick={closeMenu}>Future Events</NavLink>
        </li>
        <li>
          <NavLink to="/cultural-exchange" onClick={closeMenu}>Cultural Exchange</NavLink>
        </li>
        <li>
          <NavLink to="/international-education" onClick={closeMenu}>International Education</NavLink>
        </li>
        <li>
          <NavLink to="/trade-missions-and-delegations" onClick={closeMenu}>
            Trade Missions &amp; Delegations
          </NavLink>
        </li>
      </ul>

      {menuOpen && <div className="navBar__overlay" onClick={closeMenu} />}

      <button
        type="button"
        className="navBar__menuToggle"
        aria-label={menuOpen ? "Close menu" : "Open menu"}
        onClick={() => setMenuOpen((open) => !open)}
      >
        <i className={menuOpen ? "fa-solid fa-xmark" : "fa-solid fa-bars"}></i>
      </button>
    </nav>
  );
}

export default NavBar;
